export const colorPrimatives = {
  light: {
    white: "#ffffff",
    gray: {
      50: "#f5f5f5",
      100: "#efefef",
      150: "#e7e7e7",
      200: "#dcdcdc",
      300: "#bdbdbd",
      400: "#989898",
      500: "#7c7c7c",
      600: "#656565",
      700: "#525252",
      800: "#464646",
      900: "#3d3d3d",
      950: "#292929",
    },
    blue: {
      50: "#f1f9fe",
      100: "#e2f3fc",
      200: "#bfe5f8",
      300: "#86d3f3",
      400: "#46bbea",
      500: "#1ea3d9",
      600: "#107eb1",
      700: "#0f6995",
      800: "#10597c",
      900: "#134a67",
      950: "#0d2f44",
    },
    green: {
      50: "#effaf3",
      100: "#d7f4e0",
      200: "#b3e7c5",
      300: "#81d4a3",
      400: "#4dba7d",
      500: "#2a9f62",
      600: "#1e8c55",
      700: "#166640",
      800: "#145134",
      900: "#11432d",
      950: "#082619",
    },
    red: {
      50: "#fef2f2",
      100: "#ffe1e1",
      200: "#ffc9c9",
      300: "#fea3a3",
      400: "#fb6e6e",
      500: "#f34040",
      600: "#e22c2c",
      700: "#bd1818",
      800: "#9c1818",
      900: "#811b1b",
      950: "#460909",
    },
    yellow: {
      50: "#fefbec",
      100: "#fcf3c9",
      200: "#f9e78e",
      300: "#f6d453",
      400: "#f5c63d",
      500: "#eda113",
      600: "#d27c0d",
      700: "#ae580f",
      800: "#8e4412",
      900: "#753812",
      950: "#431c05",
    },
    purple: {
      50: "#f6f5fd",
      100: "#efecfb",
      200: "#e0dcf8",
      300: "#c9c0f2",
      400: "#ae9ce9",
      500: "#9174de",
      600: "#7f56d1",
      700: "#754bc0",
      800: "#5d389f",
      900: "#4d3082",
      950: "#301d58",
    },
    brand: {
      50: "#effaff",
      100: "#def3ff",
      200: "#b6eaff",
      300: "#75dbff",
      400: "#2ccaff",
      500: "#00adee",
      600: "#0090d4",
      700: "#0072ab",
      800: "#00608d",
      900: "#065074",
      950: "#04334d",
    },
    charcoal: {
      50: "#f6f6f6",
      100: "#e7e7e7",
      200: "#d1d1d1",
      300: "#b0b0b0",
      400: "#888888",
      500: "#6d6d6d",
      600: "#5d5d5d",
      700: "#4f4f4f",
      800: "#454545",
      900: "#3d3d3d",
      950: "#1c1c1c",
    },
    fog: {
      50: "#f4f7fa",
      100: "#e2e8f0",
      200: "#d4dde9",
      300: "#b6c7da",
      400: "#93aac7",
      500: "#7991b8",
      600: "#677ca9",
      700: "#5b6c9a",
      800: "#4e5a7f",
      900: "#424b66",
      950: "#2b3040",
    },
    foam: {
      50: "#f9f6f3",
      100: "#f5f0ea",
      200: "#e3d4c5",
      300: "#d1b8a0",
      400: "#bd967a",
      500: "#b07e5f",
      600: "#a26d54",
      700: "#875847",
      800: "#6e493e",
      900: "#5a3d34",
      950: "#301e1a",
    },
    rpa: {
      50: "#ededfd",
      100: "#e0e0fa",
      200: "#cbcaf6",
      300: "#b1adf0",
      400: "#978ce8",
      500: "#8873de",
      600: "#7a59cf",
      700: "#6a49b6",
      800: "#563d8f",
      900: "#4c3a7e",
    },
    calm: {
      50: "#eef2f7",
      100: "#e0e9f0",
      200: "#cdd8e5",
      300: "#bfcfdf",
      400: "#92adc8",
      500: "#7895ba",
      600: "#647daa",
      700: "#596d9b",
      800: "#4d5a80",
      900: "#414d68",
    },
    neutral: {
      10: "#ffffff",
      100: "#ffffff",
      200: "#ffffff",
      300: "#ffffff",
    },
  },
  dark: {
    gray: {
      50: "#1d1d1d",
      100: "#262626",
      200: "#323232",
      300: "#3f3f3f",
      400: "#545454",
      500: "#707070",
      600: "#909090",
      700: "#b2b2b2",
      800: "#d1d1d1",
      900: "#ebebeb",
      950: "#ffffff",
    },
    blue: {
      50: "#003877",
      100: "#00418a",
      200: "#004da3",
      300: "#0059c2",
      400: "#0367e0",
      500: "#1379f3",
      600: "#348ff4",
      700: "#54a3f6",
      800: "#72b7f9",
      900: "#8fcafc",
      950: "#8fcafc",
    },
    green: {
      50: "#044329",
      100: "#004e2f",
      200: "#005c38",
      300: "#006c43",
      400: "#007d4e",
      500: "#008f5d",
      600: "#12a26c",
      700: "#2bb47d",
      800: "#43c78f",
      900: "#5ed9a2",
      950: "#81e9b8",
    },
    red: {
      50: "#7b0000",
      100: "#8d0000",
      200: "#a50000",
      300: "#be0403",
      400: "#d71913",
      500: "#ea3829",
      600: "#f65843",
      700: "#ff755e",
      800: "#ff9581",
      900: "#ffb0a1",
      950: "#ffc9bd",
    },
    orange: {
      50: "#662500",
      100: "#752d00",
      200: "#893700",
      300: "#9e4200",
      400: "#b44e00",
      500: "#ca5d00",
      600: "#e16d00",
      700: "#f4810c",
      800: "#fe9a2e",
      900: "#ffb558",
      950: "#fdce88",
    },
    indigo: {
      50: "#282c8c",
      100: "#2f34a3",
      200: "#393fbb",
      300: "#464bd3",
      400: "#555be7",
      500: "#686df4",
      600: "#7c81fb",
      700: "#9195ff",
      800: "#a7aaff",
      900: "#bcbeff",
      950: "#d0d2ff",
    },
    neutral: {
      10: "#000000",
      100: "#000000",
      200: "#000000",
      300: "#000000",
    },
  },
} as const;

export type ColorPrimatives = typeof colorPrimatives;
export type ColorTheme = keyof ColorPrimatives;
export type ColorFamily = keyof ColorPrimatives["light"];
export type ColorShade = keyof ColorPrimatives["light"]["gray"];
